module.exports = __webpack_public_path__ + "static/Costco_pin_hover-43873fe9c98102fea8fe6d452acd35b2.png";